import { useEffect, useRef, useState } from "react";
// import rosa from "../Assets/";
import blau from "../Assets/CHECKLISTE KLINIKTASCHE_blau.pdf";
import rosa from "../Assets/CHECKLISTE KLINIKTASCHE_rosa.pdf";
import mein from "../Assets/Meine Schwangerschaftsbegleiter.pdf"
import "video.js/dist/video-js.css";
const popupStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999,
  },
  content: {
    position: "relative",
    backgroundColor: "none",
    padding: "0",
    borderRadius: "10px",
    width: "90%",
    maxWidth: "900px",
    // overflow: "hidden",
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    background: "#3f3f3fcf",
    color: "#fff",
    border: "none",
    padding: "5px 10px",
    cursor: "pointer",
    zIndex: 9,
    borderRadius: "50%",
    height: "34px",
    width: "34px",
    fontSize: "1.2em",
  },
};

const VideoModal = ({ show, videoSrc, onClose, title = "", videoEndFunc = () => { return false }, flag, pdf }) => {
  const videoRef = useRef(null);
  const [showOverlay, setShowOverlay] = useState(true);
  const [isPaused, setIsPaused] = useState(true);
  useEffect(() => {
    const video = videoRef.current;
    let overlayTimer;

    const handlePlay = () => {
      setIsPaused(false);
      clearTimeout(overlayTimer);
      overlayTimer = setTimeout(() => {
        setShowOverlay(false);
      }, 2500);

    };

    const handlePause = () => {
      setIsPaused(true);
      setShowOverlay(true);
      clearTimeout(overlayTimer);
    };

    const handleMouseMove = () => {
      setShowOverlay(true);

      if (!isPaused) {
        clearTimeout(overlayTimer);
        overlayTimer = setTimeout(() => {
          setShowOverlay(false);
        }, 2500);
      }
    };

    video?.addEventListener("play", handlePlay);
    video?.addEventListener("pause", handlePause);
    video?.addEventListener("mousemove", handleMouseMove);
    console.log(show)
    return () => {
      video?.removeEventListener("play", handlePlay);
      video?.removeEventListener("pause", handlePause);
      video?.removeEventListener("mousemove", handleMouseMove);
      clearTimeout(overlayTimer);
    };

  }, [show, isPaused]);

  // const handleDownload = async () => {
  //   try {
  //     const slug = "meine-kliniktasche";
  //     const response = await fetch(`${BASE_URL}/download-pdf/${slug}`);

  //     if (!response.ok) throw new Error("Download failed");

  //     const blob = await response.blob();
  //     const url = window.URL.createObjectURL(blob);

  //     // Extract filename from Content-Disposition header
  //     let filename = "download.pdf";
  //     const disposition = response.headers.get("Content-Disposition");
  //     console.log(disposition)
  //     const match = disposition?.match(/filename="?([^"]+)"?/);
  //     if (match?.[1]) filename = match[1];

  //     console.log(filename)
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = filename;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (err) {
  //     console.error("PDF Download Failed:", err);
  //   }
  // };

 const handleDownload = (flag) => {
  let filename = "";
  let fileUrl = "";

  if (flag === "rosa") {
    filename = "CHECKLISTE KLINIKTASCHE_rosa.pdf";
    fileUrl = rosa;
  } else if (flag === "blau") {
    filename = "CHECKLISTE KLINIKTASCHE_blau.pdf";
    fileUrl = blau;
  } else if (flag === "mein") {
    filename = "MEINE SCHWANGERSCHAFTSBEGLEITER.pdf";
    fileUrl = mein;
  } else {
    console.error("Invalid flag");
    return;
  }

  const a = document.createElement("a");
  a.href = fileUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};


  if (!show) return null;

  return (
    <div className="popup-overlay" style={popupStyles.overlay}>
      <div className={`popup-content ${flag === "meine-kliniktasche" || flag === "mein-schwangerschafts-update"
        ? "popup-content-modal"
        : ""
        }`}
        style={popupStyles.content}
      >
        <button onClick={onClose} style={popupStyles.closeButton}><i class="fa-solid fa-xmark"></i></button>

        {/* Always show when paused, never when playing */}
        {/* {showOverlay && title && (
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              background: "rgba(0, 0, 0, 0.6)",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: "6px",
              zIndex: 2,
              transition: "opacity 0.3s ease",
              cursor: "default",
            }}
          >
            {title}
          </div>
        )} */}

        <video
          ref={videoRef}
          id="my-video"
          className="video"
          width="100%"
          playsInline
          autoPlay
          controls
          controlsList="nodownload"
          style={{ verticalAlign: "bottom" }}
          onContextMenu={(e) => e.preventDefault()}
          onEnded={(e) => { videoEndFunc(e) }}
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
        {(flag === "meine-kliniktasche" || flag === "mein-schwangerschafts-update") && (
          <div className="videoinfo">
            <div className="videoinfobx">
              {flag === "mein-schwangerschafts-update" && (
                // <p>Nutze den Code SHAPESARAH für samion.com</p>
                // <p>Verwöhne dich und deine Haut in der Schwangerschaft mit der natürlichen Pflege von samion. Mit dem Code SHAPESARAH erhältst du 20 % Rabatt auf das gesamte mommy&baby und woman Sortiment. Du wirst es lieben!</p>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                
                  <button
                    className="downloadbtn"
                    onClick={()=> handleDownload("mein")}
                    style={{ background: "#dec2b5"}}
                  >
                    <span>MEINE SCHWANGERSCHAFTSBEGLEITER</span>
                    <i className="fas fa-cloud-download-alt"></i>
                  </button>
                </div>
              
              )}

              {flag === "meine-kliniktasche" && (
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <button className="downloadbtn" onClick={()=> handleDownload("rosa")}>
                    <span>Hier findest du die Checkliste in rosa</span>
                    <i className="fas fa-cloud-download-alt"></i>
                  </button>
                  <button
                    className="downloadbtn"
                    onClick={()=> handleDownload("blau")}
                    style={{ background: "#57B9FF"}}
                  >
                    <span>Hier findest du die Checkliste in blau</span>
                    <i className="fas fa-cloud-download-alt"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoModal;


